export const PLAYER_HEALTH_LOADED = 'player_health.LOADED';
export const PLAYER_HEALTH_UPDATED = 'player_health.UPDATED';
export const PLAYER_HEALTH_UI_HANDLED_LATEST_CHANGE = 'player_health.UI_HANDLED_LATEST_CHANGE';
